
export default function StatusBadge({ status }) {
    const styles = {
        pending: "bg-yellow-100 text-yellow-800",
        approved: "bg-green-100 text-green-800",
        rejected: "bg-red-100 text-red-800",
        archived: "bg-gray-100 text-gray-800",
        draft: "bg-blue-100 text-blue-800"
    };

    const labels = {
        pending: "На проверке",
        approved: "Утвержден",
        rejected: "Отклонен",
        archived: "В архиве",
        draft: "Черновик"
    };

    const statusKey = status?.toLowerCase() || 'draft';
    const className = styles[statusKey] || styles.draft;
    const label = labels[statusKey] || status;

    return (
        <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${className}`}>
            {label}
        </span>
    );
};
